import { render } from "./compromisopago.vue?vue&type=template&id=83831c9a"
import script from "./compromisopago.vue?vue&type=script&lang=js"
export * from "./compromisopago.vue?vue&type=script&lang=js"

import "./compromisopago.vue?vue&type=style&index=0&id=83831c9a&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-cliente-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__